export const IMAGES_BASE_PATH = '/images/showroom360';
export const ACCESSORY_DESCRIPTION_MAX_LENGTH = 115;
